// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"836af079","500":"d7b4dbf0","992":"47857c69"}[chunkId] + ".chunk.css";
};